export default function isAdmin(user) {
    if (!user) return false;
    if (user.role === "Super Admin" || user.role === "Admin") return true;
    return false;
}
